import { Link as RouterLink } from "react-router-dom";

// Rodape das paginas publicas. Extraido do index.js da landing quando a
// pagina de podcast passou a existir: uma segunda pagina sem rodape
// pareceria inacabada, e duplicar 120 linhas de marcacao garantiria
// divergencia entre as duas.
export default function LandingFooter() {
  return (
      <footer style={{
        borderTop: "1px solid rgba(255,255,255,0.07)",
        padding: "4rem clamp(1.5rem, 8vw, 9rem) 2rem",
      }}>
        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
          gap: "3rem",
          marginBottom: "3rem",
        }}>
          {/* Coluna 1 — logo + descrição + social */}
          <div>
            <RouterLink to="/" style={{ display: "inline-block", marginBottom: "1rem" }}>
              <img src="/static/images/logo/logoyouon.svg" alt="Youon" style={{ height: 28 }} />
            </RouterLink>
            <p style={{
              fontSize: "0.85rem",
              color: "rgba(255,255,255,0.35)",
              lineHeight: 1.7,
              margin: "0 0 1.5rem",
              maxWidth: 260,
            }}>
              A plataforma de engajamento ao vivo para TV, podcasts e eventos. Receba mensagens do público, modere e exiba na tela em segundos.
            </p>
            <div style={{ display: "flex", gap: "0.75rem" }}>
              {[
                { label: "Instagram", href: "https://instagram.com/youonapp", icon: (
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="2" y="2" width="20" height="20" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"/>
                  </svg>
                )},
                { label: "YouTube", href: "https://youtube.com/@youonapp", icon: (
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M22.54 6.42a2.78 2.78 0 0 0-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46A2.78 2.78 0 0 0 1.46 6.42 29 29 0 0 0 1 12a29 29 0 0 0 .46 5.58 2.78 2.78 0 0 0 1.95 1.97C5.12 20 12 20 12 20s6.88 0 8.59-.45a2.78 2.78 0 0 0 1.95-1.97A29 29 0 0 0 23 12a29 29 0 0 0-.46-5.58z"/>
                    <polygon points="9.75 15.02 15.5 12 9.75 8.98 9.75 15.02" fill="currentColor" stroke="none"/>
                  </svg>
                )},
                { label: "Facebook", href: "https://facebook.com/youonapp", icon: (
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
                  </svg>
                )},
              ].map((s) => (
                <a key={s.label} href={s.href} target="_blank" rel="noreferrer" aria-label={s.label} style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: 36,
                  height: 36,
                  borderRadius: 8,
                  border: "1px solid rgba(255,255,255,0.1)",
                  color: "rgba(255,255,255,0.4)",
                  textDecoration: "none",
                  transition: "color 0.2s, border-color 0.2s",
                }}>
                  {s.icon}
                </a>
              ))}
            </div>
          </div>

          {/* Coluna 2 — links */}
          <div>
            <p style={{ fontSize: "0.75rem", fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase", color: "rgba(255,255,255,0.25)", margin: "0 0 1.25rem" }}>Links</p>
            <div style={{ display: "flex", flexDirection: "column", gap: "0.75rem" }}>
              {[
                { label: "Entrar", to: "/account/login" },
                { label: "Criar conta grátis", to: "/account/register" },
                { label: "Termos de uso", href: "https://www.youon.app/termos-de-uso/" },
              ].map((l) => (
                l.to ? (
                  <RouterLink key={l.label} to={l.to} style={{ fontSize: "0.875rem", color: "rgba(255,255,255,0.4)", textDecoration: "none" }}>{l.label}</RouterLink>
                ) : (
                  <a key={l.label} href={l.href} target="_blank" rel="noreferrer" style={{ fontSize: "0.875rem", color: "rgba(255,255,255,0.4)", textDecoration: "none" }}>{l.label}</a>
                )
              ))}
            </div>
          </div>

          {/* Coluna 3 — contato */}
          <div>
            <p style={{ fontSize: "0.75rem", fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase", color: "rgba(255,255,255,0.25)", margin: "0 0 1.25rem" }}>Contato</p>
            <div style={{ display: "flex", flexDirection: "column", gap: "0.75rem" }}>
              <span style={{ fontSize: "0.875rem", color: "rgba(255,255,255,0.4)", lineHeight: 1.6 }}>
                Rua Iririu, 1327<br />
                Bairro Saguaçu<br />
                Joinville – SC, CEP 89.221-515
              </span>
              <a href="https://wa.me/551148632226" target="_blank" rel="noreferrer" style={{ fontSize: "0.875rem", color: "rgba(255,255,255,0.4)", textDecoration: "none" }}>
                WhatsApp: (11) 4863-2226
              </a>
              <a href="mailto:comercial@whatstv.com.br" style={{ fontSize: "0.875rem", color: "rgba(255,255,255,0.4)", textDecoration: "none" }}>
                comercial@whatstv.com.br
              </a>
            </div>
          </div>
        </div>

        {/* linha divisória + copyright */}
        <div style={{
          borderTop: "1px solid rgba(255,255,255,0.06)",
          paddingTop: "1.5rem",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: "0.75rem",
        }}>
          <span style={{ fontSize: "0.78rem", color: "rgba(255,255,255,0.2)" }}>
            © 2015 Todos os direitos reservados Youon.
          </span>
          <span style={{ fontSize: "0.78rem", color: "rgba(255,255,255,0.15)" }}>
            Feito para emissoras de TV ao vivo
          </span>
        </div>
      </footer>
  );
}
